<template>
  <div class="cardHead">
    <div class="system">
      <img src="@/assets/images/logo.png" />
      <span>宫颈细胞TBS智能诊断系统 </span>

      <template v-if="isBack">
        <a class="reBack" @click="reBack">返回上一页</a>
      </template>
    </div>
    <div class="userBox">
      <template v-if="showEdit">
        <a v-if="cancelEdit" class="addDrag" @click="cancelDrage">
          <!-- <img src="@/assets/images/add.png" /> -->
          取消标记
        </a>
        <a v-else class="addDrag" @click="addDrage">
          <!-- <img src="@/assets/images/add.png" /> -->
          添加标记
        </a>
      </template>

      <span>{{ userData.nickName }}</span>
      <a @click="loOut">
        <img src="@/assets/images/getOut.png" />
        退出
      </a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./head.scss";
</style>

<script>
export default {
  props: ["isBack", "showEdit", "cancelEdit"],
  data() {
    return {
      userData: "",
    };
  },
  created() {
    this.getUser();
    let that = this;
  },
  components: {},
  mounted() {},
  methods: {
    reBack() {
      this.$router.go(-1);
    },
    getUser() {
      let that = this;
      that.ajax.get("sys/loginUser").then((res) => {
        that.userData = res.data;
        sessionStorage.setItem("userData", JSON.stringify(res.data));
        this.$emit("childFun", res.data);
      });
    },
    getOut() {
      let that = this;
      that.ajax.post("/sys/logout").then((res) => {
        that.$toast({
          message: "退出成功",
          onClose() {
            sessionStorage.setItem("user", "");
            that.$router.replace({ name: "Login" });
          },
        });
      });
    },
    loOut() {
      let that = this;
      this.$dialog
        .alert({
          message: "确认退出？",
          showCancelButton: true,
          confirmButtonColor: "#409eff",
        })
        .then(() => {
          that.getOut();
          localStorage.setItem("autoLogin", false);
        });
    },
    cancelDrage() {
      let that = this;
      that.$emit("cancelDrage", false);
    },
    addDrage() {
      let that = this;
      that.$emit("addRecords", true);
    },
  },
};
</script>